import { Box, Button, Flex, Image, Modal, SegmentedControl, Text, TextInput } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { useEffect, useState } from "react";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import axios from "axios";
import { saveAs } from "file-saver";
import toast from "react-hot-toast";

const TABS = [
  {
    label: "신고필증",
    value: "ic",
  },
  {
    label: "D/O",
    value: "do",
  },
];

// Function to check if URL is an image
const isImageUrl = (url) => {
  if (!url) return false;
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
  const lowerUrl = url.toLowerCase();
  return imageExtensions.some((ext) => lowerUrl.includes(ext));
};

// Function to check if URL is a PDF
const isPdfUrl = (url) => {
  if (!url) return false;
  const lowerUrl = url.toLowerCase();
  return lowerUrl.includes(".pdf");
};

export default function OrderDetailBoseModal({
  icUrl,
  doUrl,
  plUrl,
  id,
  unipassCode: initialUnipassCode,
  mutate,
}) {
  const [opened, { open, close }] = useDisclosure();
  const [tab, setTab] = useState("ic");
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [unipassCode, setUnipassCode] = useState("");

  // Get the current URL based on selected tab
  const getCurrentUrl = () => {
    switch (tab) {
      case "ic":
        return icUrl;
      case "do":
        return doUrl;
      case "pl":
        return plUrl;
      default:
        return null;
    }
  };

  const currentUrl = getCurrentUrl();
  const isImage = isImageUrl(currentUrl);
  const isPdf = isPdfUrl(currentUrl);

  async function handleDownload(url) {
    const response = await fetch(url, { mode: "cors", cache: "no-cache" });
    const blob = await response.blob();
    const filename = url.split("/").pop();
    saveAs(blob, `수출입_서류_${filename}`);
    toast.success("다운로드 완료");
  }

  async function handleSaveUnipassCode() {
    if (!unipassCode) {
      toast.error("화물관리번호를 입력해주세요");
      return;
    }

    await axios({
      url: `/orders/${id}`,
      method: "PUT",
      data: {
        data: {
          unipassCode,
        },
      },
    });

    toast.success("화물관리번호 저장 완료");
    mutate();
  }

  useEffect(() => {
    if (opened && initialUnipassCode) {
      setUnipassCode(initialUnipassCode);
    }
  }, [opened]);

  return (
    <>
      <Button fullWidth onClick={open} color="blue" disabled={!icUrl && !doUrl && !plUrl}>
        수출입 서류
      </Button>

      <Modal opened={opened} onClose={close} title="수출입 서류" zIndex={1000} size="lg">
        <SegmentedControl
          fullWidth
          data={TABS}
          mb="sm"
          value={tab}
          onChange={(value) => setTab(value)}
        />
        <Box mb="sm">
          <TextInput
            label="화물관리번호"
            placeholder="화물관리번호를 입력해주세요"
            value={unipassCode}
            onChange={(e) => setUnipassCode(e.target.value)}
          />
          <Button fullWidth onClick={handleSaveUnipassCode}>
            화물관리번호 저장
          </Button>
        </Box>
        <Box mb="lg">
          {currentUrl && (
            <>
              {isImage && (
                <>
                  <Image
                    src={currentUrl}
                    alt={`${tab.toUpperCase()} document`}
                    fit="contain"
                    style={{ maxHeight: "70vh" }}
                  />
                  <Flex justify="flex-end" mt="sm">
                    <Button onClick={() => handleDownload(currentUrl)}>다운로드</Button>
                  </Flex>
                </>
              )}
              {isPdf && (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                  <Viewer plugins={[defaultLayoutPluginInstance]} fileUrl={currentUrl} />
                </Worker>
              )}
              {!isImage && !isPdf && (
                <Text c="dimmed" ta="center" py="xl">
                  지원하지 않는 파일 형식입니다.
                </Text>
              )}
            </>
          )}
          {!currentUrl && (
            <Text c="dimmed" ta="center" py="xl">
              해당 서류가 없습니다.
            </Text>
          )}
        </Box>
      </Modal>
    </>
  );
}
